import { useState } from 'react';
import {
  FunctionField,
  useNotify,
} from 'react-admin';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SERVER_URL } from '../../../../../config';
import { exporterSingle, downloadValidationCsv } from '../../../utils';

// Labels dos itens do menu (altere aqui para mudar os nomes exibidos)
const MENU_LABELS = {
  export: 'CSV do Painel',
  exporting: 'Exportando...',
  download: 'CSV com feedbacks',
  downloading: 'Baixando...',
  downloadUnavailable: 'CSV com feedbacks indisponível',
};

const fetchDetailedData = async (panelId) => {
  const url = `${SERVER_URL}/panels/${encodeURIComponent(panelId)}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    if (!response.ok) throw new Error('Network response was not ok');
    return response.json();
  } catch (error) {
    console.error('Failed to fetch detailed data:', error);
    return null;
  }
};

const PanelRowActionsMenuContent = ({ record }) => {
  const notify = useNotify();
  const [anchorEl, setAnchorEl] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const handleExport = async (event) => {
    event.stopPropagation();
    handleClose();
    if (!record?.id) return;
    setExporting(true);
    try {
      const detailedData = await fetchDetailedData(record.id);
      if (detailedData) {
        exporterSingle(detailedData);
        notify('Exportação concluída', { type: 'success' });
      } else {
        notify('Falha ao exportar dados', { type: 'warning' });
      }
    } finally {
      setExporting(false);
    }
  };

  const handleDownload = async (event) => {
    event.stopPropagation();
    handleClose();
    if (!record?.id) {
      notify('Painel não encontrado', { type: 'warning' });
      return;
    }
    setDownloading(true);
    notify('Download em andamento, por favor aguarde…', { type: 'info' });
    try {
      await downloadValidationCsv({ panelId: record.id, panelName: record.name });
      notify('Download concluído com sucesso', { type: 'success' });
    } catch (error) {
      notify(`Erro ao baixar CSV: ${error.message}`, { type: 'warning' });
    } finally {
      setDownloading(false);
    }
  };

  const hasCsvOutput = Boolean(record?.csvOutputUrl);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        aria-label="Mais ações"
        aria-controls={open ? 'panel-row-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="panel-row-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ onClick: (e) => e.stopPropagation() }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleExport} disabled={exporting}>
          <ListItemIcon>
            {exporting ? <CircularProgress size={20} /> : <GetAppIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText primary={exporting ? MENU_LABELS.exporting : MENU_LABELS.export} />
        </MenuItem>
        <MenuItem onClick={handleDownload} disabled={!hasCsvOutput || downloading}>
          <ListItemIcon>
            {downloading ? <CircularProgress size={20} /> : <CloudDownloadIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText
            primary={downloading ? MENU_LABELS.downloading : MENU_LABELS.download}
            secondary={!hasCsvOutput ? MENU_LABELS.downloadUnavailable : null}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

const PanelRowActionsMenu = (props) => (
  <FunctionField
    label="Ações"
    render={(record) => <PanelRowActionsMenuContent record={record} />}
    {...props}
  />
);

export default PanelRowActionsMenu;
